import type { ViewerPluginCreator } from './../ricos-types';

import SpoilerViewerWrapper from './Components/Wrappers/SpoilerViewerWrapper';
import type { SpoilerPluginViewerConfig } from './types';
import { SPOILER_TYPE } from './types';
import { initSpoilersContentState } from './utils/spoilerUtilsFn';
export { initSpoilersContentState, SpoilerViewerWrapper };

import nodeViewDecorator from './nodeViewDecorator';

export const pluginSpoiler: ViewerPluginCreator<SpoilerPluginViewerConfig> = config => {
  return {
    config: { initSpoilersContentState, SpoilerViewerWrapper, ...config },
    type: SPOILER_TYPE,
    nodeViewDecorators: [nodeViewDecorator],
  };
};
